export default __webpack_public_path__ + "icon-sft0c51f9.png";